export default __webpack_public_path__ + "d1fb72824e0dc921ef8d310a39fd3411.svg";